/* eslint-disable jsx-a11y/anchor-is-valid */

import { useState } from "react";

const DropdownItem = ({ children, onClick, className }) => (
    <a className={`dropdown-item ${className}`} onClick={onClick}>
        {children}
    </a>
);

const DropdownItemWrapper = ({ activeOption, dismissal, onClick, className, ...props }) => {
    const isActiveClass = () => {
        return activeOption === props.children ? 'is-active' : '';
    }

    const handleClick = () => {

        if (onClick) {
            onClick();
        }

        dismissal();
    }

    return (
        <DropdownItem onClick={handleClick} className={`${className} ${isActiveClass()}`} {...props} />
    );
};

const Dropdown = ({ id, className, activeOption, disabled, children }) => {
    const [dropdown, setDropdown] = useState(false);

    const toggleDropdown = () => {
        setDropdown(!dropdown);
    }

    if (disabled) {
        return <button className="button is-light is-outlined has-text-dark is-static">{activeOption}</button>;
    }

    return (
        <div className={`dropdown ${dropdown ? "is-active" : ""} ${className}`}>
            <div className="dropdown-trigger">
                <button className="button" aria-haspopup="true" aria-controls={id} onClick={toggleDropdown}>
                    <span>{activeOption}</span>
                    <span className="icon is-small">
                        <i className="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </button>
            </div>

            <div className="dropdown-menu" id={id} role="menu">
                <div className="dropdown-content">
                    {children.map((child, index) => (
                        <DropdownItemWrapper key={`dd-${index}`} activeOption={activeOption} dismissal={toggleDropdown} {...child.props}></DropdownItemWrapper>
                    ))}
                </div>
            </div>
        </div>
    );
};

export { Dropdown, DropdownItem };
